import logger from '@/services/logging';

export const requestInterceptHandler = (config) => {
  if (
    typeof location !== 'undefined' &&
    !config.baseURL.includes(location.host)
  ) {
    logger.error('process.env.HOST is incorrect');
    const error = new Error('process.env.HOST is incorrect');
    return Promise.reject(error);
  }

  return config;
};

export const responseInterceptErrorHandler = (error) => {
  errorHandler(error);
  throw error;
};

export const errorHandler = (error) => {
  if (
    error.response &&
    error.response.data &&
    error.response.data.error_code === 20002 &&
    error.response.data.stack.indexOf('MYIAccountNotFoundError') > -1
  ) {
    logger.warn('myi.response.data: ', error.response.data);
    logger.warn('myi.response.status: ', error.response.status);
    logger.warn('myi.response.headers: ', error.response.headers);
  } else if (error.response) {
    // Request made and server responded
    logger.error('error.response.data: ', error.response.data);
    logger.error('error.response.status: ', error.response.status);
    logger.error('error.response.headers: ', error.response.headers);
  } else if (error.request) {
    // The request was made but no response was received
    logger.error('error.request:', error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    logger.error('Error:', error.message);
  }
};

export const addDelayOnBuild = (delay = 500) => {
  if (!process.env.IS_BUILD) {
    return;
  }

  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};
